import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ButtonModule } from '../../../common/button/button.module';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';
import { HEALTHFIRST_HOME_INFO } from './home-info';
import { HealthFirstService } from '../../services/health-first.service';
import { RouterLink, Router } from '@angular/router';
import { TypeDeleteModule } from 'src/app/common/type-delete/type-delete.module';
import { ModuleLoaderModule } from 'src/app/common/module-loader/module-loader.module';
import { HfPlanInfoComponent } from '../hf-plan-info/hf-plan-info.component';
import { HfBenefitDetailComponent } from '../hf-benefit-detail/hf-benefit-detail.component';
import { HfPlanDetailsComponent } from '../hf-plan-details/hf-plan-details.component';
import { HfCommentsComponent } from '../hf-comments/hf-comments.component';
import { HfPlanDetailsMobComponent } from '../hf-plan-details-mob/hf-plan-details-mob.component';
import { HfContactSectionComponent } from '../hf-contact-section/hf-contact-section.component';
import { HfCommentsSectionComponent } from '../hf-comments-section/hf-comments-section.component';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-hf-home',
  standalone: true,
  imports: [
    CommonModule,
    TypeDeleteModule,
    MatButtonModule,
    ButtonModule,
    NgxGlideModule,
    MatIconModule,
    ModuleLoaderModule,
    HfPlanInfoComponent,
    HfBenefitDetailComponent,
    HfPlanDetailsComponent,
    HfCommentsComponent,
    HfPlanDetailsMobComponent,
    HfContactSectionComponent,
    HfCommentsSectionComponent,
    RouterLink,
    SwiperModule
  ],
  templateUrl: './hf-home.component.html',
  styleUrls: ['./hf-home.component.scss']
})
export class HfHomeComponent {
  constructor(
    private events: EventsService,
    public util: UtilService,
    private hfService: HealthFirstService,
    public vars: VariablesService,
    private router: Router) {}
  dashboardLoading = false;
  platformBrowser = false;

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: true,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 2,
        centeredSlides: false,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        spaceBetween: 8,
        initialSlide: 0,
        observer: true,
      },
    }
  }

  @ViewChild('hfBenefitDetialRef') hfBenefitDetialRef;
  info = HEALTHFIRST_HOME_INFO;
  bannerImg = false;
  planAmountData = null;
  planBenefitsBreakpoints = {
    992: {
      slidesPerView: '3',
      init: true,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: '2',
      init: true,
      spaceBetween: 10
    }
  }

  ngOnInit() {
    this.vars.pageName = 'healthfirst_homepage'
    this.checkHfData();
  }

  checkHfData() {
    if (this.vars.hfDashboardData && Object.keys(this.vars.hfDashboardData).length > 0) {
      this.setInfoData(this.vars.hfDashboardData);
    } else {
      this.getHealthPlans();
    }
  }

  getHealthPlans() {
    this.dashboardLoading = true;
    this.hfService.getHealthFirstData()
      .subscribe(data => {
        if (data) {
          this.vars.hfDashboardData = null;
          this.vars.hfDashboardData = data;
          this.setInfoData(data);
        }
      })
  }

  setInfoData(data) {
    this.info.plansMob = [];
    const { experience_saving, offers, policies, testimonials, why_should_choose, calculate, recommended_plan } = data.data.healthfirst;
    this.planAmountData = policies.plans;
    this.info.recommended_plan = recommended_plan
    this.info.planDetails.plans = policies.details;
    this.info.calculator.title = calculate.info_1;
    this.info.calculator.amount = calculate.info_2;
    this.info.calculator.subTitle = calculate.info_3;
    this.info.calculator.desc = calculate.info_4;
    for (const key in policies.plans) {
      if (Object.prototype.hasOwnProperty.call(policies.plans, key)) {
        const element = policies.plans[key];
        this.info.plansMob.push({
          plan: key,
          duration: Object.keys(element)[0],
          amount: element.yearly.amount,
          planId: element.yearly.planId,
          benefits: [...element.yearly.benefits]
        });
      }
    }

    this.info.plans = policies.benefits.filter(item => 'info_1' in item);
    this.info.planBenefits = offers;
    this.info.wordArray = experience_saving;
    this.info.commentsSection.comments = testimonials;
    this.info.benefits = why_should_choose;
    this.dashboardLoading = false;
  }

  onExplorePlanClicked() {
    this.events.sendSystemEvent({
      eventName: 'find_my_plan',
    }).subscribe(_ => _);
    this.events.claverTapPush('Healthfirst find my plan', {
      'Event Name': 'find_my_plan',
    });
    this.hfService.selectedBenefit = null;
    this.router.navigate(['/healthfirst/plans']);
  }

  calcClick() {
    this.events.sendSystemEvent({
      eventName: 'calculate_now',
    }).subscribe(_ => _);
    this.events.claverTapPush('Healthfirst calculate now', {
      'Event Name': 'calculate_now',
    });
  }
}
